import BlankBill from "../blankbill";
import { connect } from "react-redux";
import React, { Component } from "react";
import TableBill from "../../tableProvider/table-bill";
import {
  getBillsList,
  clearBillsList,
} from "../../../../Redux/actions/billActions";
import { getBills, getTotalElements } from "../../../../Redux/reducer/bills";

export class ByStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      sizePerPage: this.props.pageSize,
      filters: [],
      byStatus: "",
      componentReady: false,
    };
  }

  componentDidMount() {
    if(this.props.pageSize !== 10){
      this.props.handlePageSizeSelection(10);
      return;
    }
    this.props.handleBillSelection(this.props.defaultBillSelection);
    this.props.reset();
    return this.loadBills();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pageSize !== this.props.pageSize) {
      this.props.setModal(true)
      this.setState({ sizePerPage: this.props.pageSize, page: 0 }, () => {
        this.loadBills()
      });
    }

    var customFilters = this.getFilters();
    if (JSON.stringify(customFilters) !== JSON.stringify(this.state.filters)) {
      this.setState({ filters: customFilters });
      this.loadBills();
    }
  }

  componentWillUnmount() {
    this.props.handlePageSizeSelection(10);
    this.props.clearBillsList();
    this.props.setModal(true);
  }

  loadBills() {
    var customFilters = this.getFilters();
    this.setState({ filters: customFilters });
    return this.props
      .getBillsList(this.state.page, this.state.sizePerPage, customFilters)
      .then(() => {
        this.props.setModal(false);
        this.setState({ componentReady: true, filters: customFilters });
      });
  }

  getFilters() {
    var customFilters = [...this.props.filters];
    if (this.props.byStatus !== "") {
      // if (this.props.byStatus !== '' && this.state.byStatus !== this.props.byStatus) {
      let opertator = "eq";
      if (this.props.byStatus.split(",").length > 1) {
        opertator = "in";
      }
      customFilters.push({
        property: "status",
        operator: opertator,
        value: this.props.byStatus,
      });
    }

    return customFilters;
  }

  getBillsHandler = (page, sizePerPage, paramfilters, sortFilter) => {
    this.props.setModal(true);
    return this.props
      .getBillsList(page, sizePerPage, paramfilters, sortFilter)
      .then(() => {
        this.setState({ page: page, sizePerPage: sizePerPage });
        this.props.setModal(false);
      });
  };

  render() {
    const { componentReady, page, sizePerPage, filters } = this.state;
    const { bills, totalElements, updateCreditLine, billSelection, handleBillSelection } = this.props;

    return componentReady ? (
      bills.length > 0 ? (
        <TableBill
          data={bills}
          page={page}
          getBillsList={this.getBillsHandler}
          totalSize={totalElements}
          sizePerPage={sizePerPage}
          filters={filters}
          updateCreditLine={updateCreditLine}
          approvedTo={`PENDING`}
          mode="by-status"
          needActions={true}
          notApproved={true}
          defaultBillSelection={this.props.defaultBillSelection}
          billSelection={billSelection}
          handleBillSelection={handleBillSelection}
          excludedStatus={this.props.excludedStatus}
        />
      ) : (
        <BlankBill />
      )
    ) : null;
  }
}

export const mapStateToProps = (state) => {
  return {
    bills: getBills(state),
    totalElements: getTotalElements(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    getBillsList: (page, size, filters, sort) =>
      dispatch(getBillsList(page, size, filters, sort, null)),
    clearBillsList: (payload) => dispatch(clearBillsList(payload)),
  };
};

export default connect(mapStateToProps, mapDispatch)(ByStatus);
